webpackJsonp([178194643297634],{

/***/ 935:
/***/ (function(module, exports) {

	module.exports = {"p1":"Teymið okkar samanstendur af bæði tækni- og sálfræði sérfræðingum sem vinna saman að því að búa til hugbúnað sem mun bæta heiminn og hafa jákvæð áhrif á komandi kynslóðir.","p2":"Við njótum stuðnings og aðstoðar vísindasamfélagsins þar með talið með vísindaráði okkar (e. scientific advisory board) sem inniheldur háskólaprófessora frá fjórum löndum.","p3":"Okkar ástríða er að gera okkar notendur kleyft að verða besta mögulega útgáfan af þeim sjálfum bæði á sviði hugrænnar bætingar og einnig skákgetu. Rannsóknir hafa sýnt að aukin skákgeta getur haft óbeinar áhrif á námsgetu með ýmsum hætti m.a. með því að bæta sjálftraust og áhuga (e. motivation).","p4":"Við leggjum mikla áherslu á víðsýni og fjölbreytileika. Teymið okkar endurspeglar þessi gildi, en þar vinna bæði kynin og fólk með ólíka sérfræðiþekkingu og bakgrunn að sameiginlegu markmiði. Saman erum við sterkari!","p5":"Ef þú hefur áhuga á að leggja þitt lóð á vogaskálarnar hafðu þá endilega samband"}

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sidebar = __webpack_require__(21);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _reactIntl = __webpack_require__(7);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactstrap = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	
	  var content = props.content;
	  var image = props.data.ourTeamImg.childImageSharp.sizes;
	  return _react2.default.createElement(
	    _reactstrap.Container,
	    null,
	    _react2.default.createElement(
	      _sidebar2.default,
	      null,
	      _react2.default.createElement(
	        'h3',
	        { className: 'mb-2' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ourTeam' })
	      ),
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: image, className: 'my-3', backgroundColor: 'rgba(51,102,255,0.4)' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p1
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p2
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p3
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p4
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p5
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        _Link2.default,
	        { to: '/', className: 'btn btn-lg btn-warning' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'joinUs' })
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ourTeamLayout = __webpack_require__(157);
	
	var _ourTeamLayout2 = _interopRequireDefault(_ourTeamLayout);
	
	var _ourTeam = __webpack_require__(935);
	
	var _ourTeam2 = _interopRequireDefault(_ourTeam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Sk\xE1kgreind | Teymi\xF0 okkar'
	      )
	    ),
	    _react2.default.createElement(_ourTeamLayout2.default, _extends({ content: _ourTeam2.default }, props))
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-our-team-index-is-js-bf223996d968ab26d9c6.js